module.exports = __webpack_public_path__ + "static/img/red_limi.88363cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/pk/red_limi.png
// module id = Xbk7
// module chunks = 1